import { render, staticRenderFns } from "./PendingREDUR.vue?vue&type=template&id=3ca9006d"
import script from "./PendingREDUR.vue?vue&type=script&lang=js"
export * from "./PendingREDUR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports